import { useEffect, useState, useCallback } from "react"
import { useConfigFlag } from "@cloudbreakus/featurebang-react"
import { dataService } from "utils/dataService"
import { logger } from "utils/logger"

export const usePartners = ({ partnerId, showCollectLocation, answeredCall }) => {
  const [partners, setPartners] = useState([])
  const enabled4System = useConfigFlag("callsheet.locationSelect")

  // Clear partners when the interaction ID changes (prevents stale tree from previous call)
  const interactionId = answeredCall?.interaction?.id
  
  useEffect(() => {
    setPartners([])
  }, [interactionId])

  const stripParentFromTree = useCallback((partnerTree, parentId) => {
    if (!Array.isArray(partnerTree) || partnerTree.length === 0) {
      return []
    }

    const parentIndex = partnerTree.findIndex((partner) => partner?.value === parentId)
    if (parentIndex === -1) {
      return partnerTree
    }

    const parentNode = partnerTree[parentIndex]
    if (Array.isArray(parentNode?.children) && parentNode.children.length > 0) {
      return parentNode.children
    }

    return partnerTree.filter((partner) => partner?.value !== parentId)
  }, [])

  const fetchPartnerTree = useCallback(async (partnerId) => {
    try {
      const partners = await dataService.Partners.getTree({ partnerId })
      logger.debug("Successfully retrieved call Partner Tree 🌲", { partnerId, partners })
      setPartners(stripParentFromTree(partners, partnerId))
    } catch (err) {
      logger.error("Partner Tree fetch", err)
    }
  }, [stripParentFromTree])

  useEffect(() => {
    if (!partnerId || !showCollectLocation || !enabled4System || !answeredCall) {
      setPartners([])
      return
    }
    fetchPartnerTree(partnerId)
  }, [partnerId, fetchPartnerTree, showCollectLocation, enabled4System, answeredCall])

  return { partners }
}
